import React, {useRef, useEffect} from 'react';
import Datapoint from "./Datapoint";

import styles from './ParalelDatapoint.module.scss';
import { motion, useAnimation, useInView } from 'framer-motion';

const ParalelDatapoint = ({point, mergeEnd = false}) => {
    const ref = useRef(null);
    const isInView = useInView(ref, { once: true });
    const mainControls = useAnimation();

    useEffect(() => {
        if (isInView) {
            mainControls.start("visible");
        }
    }, [isInView]);

    return (
        <div className={styles.paralelContainer} ref={ref}>
            <motion.div
                className={styles.header}
                variants={{
                    hidden: { opacity: 0 },
                    visible: { opacity: 1 }
                }}
                initial="hidden"
                animate={mainControls}
                transition={{duration: 0.5}}
            >
                <h3>{point.title}</h3>
                <p>{point.description}</p>
            </motion.div>
            <div className={styles.paralel}>
                {point.paralel.map((innerPoint, index) => (
                    <div className={styles.datapoint}>
                        <Datapoint title={innerPoint.title} description={innerPoint.description} video={innerPoint.video} image={innerPoint.image} position="center" />
                        {mergeEnd ? (
                            <div className={`${styles.paralelEnd} ${index === 0 ? styles.firstParalel : ''} ${index + 1 === point.paralel.length ? styles.lastParalel : ''}`}>
                                <div className={`${styles.paralelLine} ${index === 0 ? styles.firstLine : ''} ${index + 1 === point.paralel.length ? styles.lastLine : ''}`} />
                                {index > 0 && index + 1 < point.paralel.length ? <div className={styles.verticalLine} /> : undefined}
                            </div>
                        ) : undefined}
                    </div>
                ))}
            </div>
            {mergeEnd ? (
                <div className={styles.mergeLines}>
                    <div className={styles.mergeArrow}>
                        <div className={styles.leftMerge} /><div className={styles.rightMerge} />
                    </div>
                </div>
            ) : undefined}
        </div>
    )
};

export default ParalelDatapoint;